import Footer from '../Footer'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/infoDocumentacion.scss'


export default function MovilidadReducida() {

    return (
    <>
    <section className='info-documentacion'>
        <div className='container'>
            <div style={{marginTop:'4rem'}}>
                <Breadcrumbs />
            </div>
           
            <div>
                <h1>Pasajeros con movilidad reducida</h1> 

                <label>Asistencia disponible:</label>
                <ul>
                    <li>Puedes solicitar asistencia especial y ayuda.</li>
                    <li>Puedes solicitar sillas de ruedas en la terminal para ayudarte con el embarque y desembarque.</li>
                </ul>

                <label>Adulto mayor:</label>  
                <ul>
                    <li>Reserva con anticipación y avisa a nuestro personal en caso de requerir</li>
                    <ul>
                        <li>Servicios adecuados por movilidad reducida.</li>
                        <li>Brindar asistencia de embarque y desembarque.</li>
                        <li>Dieta especial o requerimientos en la cabina.</li>
                    </ul>
                    <li>Llegada con tiempo a tu abordaje. </li>
                    <li>Lleva tus prescripciones y medicamentos.</li>
                </ul>

                <label>Mujeres Embarazadas:</label>
                <ul>
                    <li>Informa tu condición al comprar el boleto.</li>
                    <li>El médico a bordo puede realizar una valoración antes de embarcar.</li>
                </ul>


            </div>
        </div>
        <Footer />
    </section>
    </>
    )
}

